"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MFAMethod = exports.UserStatus = void 0;
/** User status */
var UserStatus;
(function (UserStatus) {
    UserStatus["ACTIVE"] = "active";
    UserStatus["BLOCKED"] = "blocked";
    UserStatus["BANNED"] = "banned";
    UserStatus["PENDING"] = "pending_invitation";
    /** Whether the user is silent and
     * Silent user doesn't have cognito account and can't login to the system. cognitoReferenceId will be filled whith placeholder value.
     * User is silent if he was created by Partner who doesn't want to invite him to the system
     * User can be activated by the Partner at any time by sending an invitation to the user and then cognito account will be created
     * Default value is false
     * */
    UserStatus["SILENT"] = "silent";
})(UserStatus = exports.UserStatus || (exports.UserStatus = {}));
/** MFA method */
var MFAMethod;
(function (MFAMethod) {
    MFAMethod["TOTP"] = "TOTP";
    MFAMethod["SMS"] = "SMS";
    MFAMethod["NOMFA"] = "NOMFA";
    MFAMethod["SMS_MFA"] = "SMS_MFA";
    MFAMethod["SOFTWARE_TOKEN_MFA"] = "SOFTWARE_TOKEN_MFA";
})(MFAMethod = exports.MFAMethod || (exports.MFAMethod = {}));
